import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'adversal': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAdversal" */
        '@fortawesome/free-brands-svg-icons/faAdversal'
    ),
    'angrycreative': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAngrycreative" */
        '@fortawesome/free-brands-svg-icons/faAngrycreative'
    ),
    'cc-visa': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCcVisa" */
        '@fortawesome/free-brands-svg-icons/faCcVisa'
    ),
    'centercode': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCentercode" */
        '@fortawesome/free-brands-svg-icons/faCentercode'
    ),
    'cloudscale': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCloudscale" */
        '@fortawesome/free-brands-svg-icons/faCloudscale'
    ),
    'connectdevelop': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faConnectdevelop" */
        '@fortawesome/free-brands-svg-icons/faConnectdevelop'
    ),
    'creative-commons-remix': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCreativeCommonsRemix" */
        '@fortawesome/free-brands-svg-icons/faCreativeCommonsRemix'
    ),
    'deskpro': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDeskpro" */
        '@fortawesome/free-brands-svg-icons/faDeskpro'
    ),
    'discourse': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDiscourse" */
        '@fortawesome/free-brands-svg-icons/faDiscourse'
    ),
    'docker': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDocker" */
        '@fortawesome/free-brands-svg-icons/faDocker'
    ),
    'dribbble': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDribbble" */
        '@fortawesome/free-brands-svg-icons/faDribbble'
    ),
    'dribbble-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareDribbble" */
        '@fortawesome/free-brands-svg-icons/faSquareDribbble'
    ),
    'drupal': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDrupal" */
        '@fortawesome/free-brands-svg-icons/faDrupal'
    ),
    'edge': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faEdge" */
        '@fortawesome/free-brands-svg-icons/faEdge'
    ),
    'etsy': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faEtsy" */
        '@fortawesome/free-brands-svg-icons/faEtsy'
    ),
    'fedex': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFedex" */
        '@fortawesome/free-brands-svg-icons/faFedex'
    ),
    'flipboard': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFlipboard" */
        '@fortawesome/free-brands-svg-icons/faFlipboard'
    ),
    'font-awesome-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareFontAwesomeStroke" */
        '@fortawesome/free-brands-svg-icons/faSquareFontAwesomeStroke'
    ),
    'github-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareGithub" */
        '@fortawesome/free-brands-svg-icons/faSquareGithub'
    ),
    'innosoft': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faInnosoft" */
        '@fortawesome/free-brands-svg-icons/faInnosoft'
    ),
    'invision': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faInvision" */
        '@fortawesome/free-brands-svg-icons/faInvision'
    ),
    'laravel': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faLaravel" */
        '@fortawesome/free-brands-svg-icons/faLaravel'
    ),
    'medium': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faMediumM" */
        '@fortawesome/free-brands-svg-icons/faMediumM'
    ),
    'odnoklassniki': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faOdnoklassniki" */
        '@fortawesome/free-brands-svg-icons/faOdnoklassniki'
    ),
    'qq': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faQq" */
        '@fortawesome/free-brands-svg-icons/faQq'
    ),
    'rocketchat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faRocketchat" */
        '@fortawesome/free-brands-svg-icons/faRocketchat'
    ),
    'square-steam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSteamSquare" */
        '@fortawesome/free-brands-svg-icons/faSteamSquare'
    ),
    'square-xing': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faXingSquare" */
        '@fortawesome/free-brands-svg-icons/faXingSquare'
    ),
    'strava': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faStrava" */
        '@fortawesome/free-brands-svg-icons/faStrava'
    ),
    'stubber': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faStubber" */
        '@fortawesome/free-brands-svg-icons/faStubber'
    ),
    'telegram': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faTelegramPlane" */
        '@fortawesome/free-brands-svg-icons/faTelegramPlane'
    ),
    'themeisle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faThemeisle" */
        '@fortawesome/free-brands-svg-icons/faThemeisle'
    ),
    'threads': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faThreads" */
        '@fortawesome/free-brands-svg-icons/faThreads'
    ),
    'untappd': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faUntappd" */
        '@fortawesome/free-brands-svg-icons/faUntappd'
    ),
    'windows': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWindows" */
        '@fortawesome/free-brands-svg-icons/faWindows'
    ),
    'wpexplorer': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWpexplorer" */
        '@fortawesome/free-brands-svg-icons/faWpexplorer'
    ),
    'xing-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faXingSquare" */
        '@fortawesome/free-brands-svg-icons/faXingSquare'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>